<template>
  <section>
    <div class="container">
      <div class="image">
        <img src="~assets/images/backpack7.jpg">
      </div>
      <div class="content">
        <div v-html="content"></div>
        <p class="text-center"><router-link to="/#donate" class="btn btn-primary btn-lg">Donate Now</router-link></p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'pencils-change-lives',
  props: ['content']
}
</script>

<style lang="scss" scoped>
@import '~assets/styles/vars';
section {
  padding: 6rem 0;
  .container {
    .image {
      margin-bottom: 2rem;
      max-width: 427px;
      img {
        max-width: 100%;
      }
    }
    @include media('tablet-wide') {
      display: flex;
      .image {
        margin-right: 5rem;
        margin-bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// PencilsChangeLives.vue?fb1317d4